import { useEffect, useState } from 'react';
import useFetch from './useFetch';

// One request per page load for every picker; a registry save calls reload(), which refreshes every mounted picker.
let llmModelsPromise;
const subscribers = new Set();

const reloadLlmModels = () => {
  llmModelsPromise = undefined;
  subscribers.forEach((notify) => notify((current) => current + 1));
};

// Select data plus a stored value that is no longer offered, so it shows as '(disabled)' instead of blank.
export const withCurrent = (data, value, label = value) =>
  !value ||
  data.some((entry) => (entry.items || [entry]).some((item) => String(item.value) === String(value)))
    ? data
    : [...data, { value, label: `${label} (disabled)`, disabled: true }];

// Returns [groups, reload]: the registry's Select-ready groups of enabled models (undefined while loading,
// null if the load failed), and a reload that invalidates the cache and refetches for every mounted instance.
const useLlmModels = () => {
  const fetch = useFetch();
  const [llmModels, setLlmModels] = useState();
  const [version, setVersion] = useState(0);

  useEffect(() => {
    subscribers.add(setVersion);
    return () => subscribers.delete(setVersion);
  }, []);

  useEffect(() => {
    // A superseded fetch must not overwrite the result of the reload that replaced it.
    let current = true;
    const promise = (llmModelsPromise ??= fetch('/api/admin/llmModels').then((response) => response.llmModels));
    promise
      .then((groups) => current && setLlmModels(groups))
      .catch(() => {
        if (llmModelsPromise === promise) {
          llmModelsPromise = undefined;
        }
        if (current) {
          setLlmModels(null);
        }
      });
    return () => {
      current = false;
    };
  }, [fetch, version]);

  return [llmModels, reloadLlmModels];
};

export default useLlmModels;
